import React, { useMemo } from 'react';
import FilterDropdown from './Filter/components/FilterDropdown';
import { translate } from '../services/translate';
import moment from 'moment';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
    hideLabel?: boolean;
}

export default function YearDropdown({ setValue, value, zIndex, hideLabel }: Props) {
    const items = useMemo(() => {
        const currentYear = moment().year();
        const startYear = currentYear - 10;
        const endYear = currentYear + 1;

        const years = [];
        for (let year = endYear; year >= startYear; year--) {
            years.push({
                label: year.toString(),
                value: year,
            });
        }
        return years;
    }, []);

    return (
        <FilterDropdown
            label={hideLabel ? undefined : translate('year')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
        />
    );
}
